import { useMutation } from '@tanstack/react-query';
import { customFetchV2 } from '../services/custom-fetch-v2';

interface CancelDeviceRequest {
  deviceId: string;
}

interface CancelDeviceResponse {}

/**
 * API call to cancel device.
 */
const cancelDevice =
  async (request: CancelDeviceRequest): Promise<CancelDeviceResponse | null> => {
    const { deviceId } = request;

    const response: any = await customFetchV2(`/api/v2/devices/${deviceId}/cancel`, {
      method: 'POST',
    });

    if (!response.ok) {
      throw new Error('Unable to cancel device');
    }

    return {};
  };

const useCancelDeviceMutation = () => {
  return useMutation({
    mutationFn: cancelDevice,
    onSuccess: () => {
      // TODO: Would make sense to invalidate related queries in here.. just need
      // to get hold of device ID and device profile ID
    },
  });
};

/** Exports */
export { useCancelDeviceMutation };
